<style>
  .card {
    cursor: pointer;
    border-style: dashed;
    border-width: 2px;
  }
</style>

<div role="button" class="card h-100 hover-scale" on:click>
  <div class="card-body d-flex justify-content-center">
    <div class="row align-items-center">
      <div class="icon-rounded bg-gray-200 mb-2">
        <i class="fa fa-plus text-lg text-dark" />
      </div>
    </div>
  </div>
</div>
